import widget from '@/public/yana-embed'
export default {
  displayWidget() {
    if (+process.env.VUE_APP_SHOW_HELP_WIDGET) {
      widget.init()
    }
  },
}
